module.exports=/[\0-\x1F\x7F-\x9F]/


/*****************
 ** WEBPACK FOOTER
 ** ./~/uc.micro/categories/Cc/regex.js
 ** module id = 769
 ** module chunks = 0
 **/